export const QUERY_DOWNLOAD_GROUP_PASSWORDS = 'downloadGroupPasswords'
export const QUERY_RESET_GROUP_PASSWORDS = 'resetGroupPasswords'
export const QUERY_UNBLOCK_GROUP_STUDENTS = 'unblockGroupStudents'
export const QUERY_GROUP_USERS = 'groupUsers'
export const QUERY_GROUP = 'group'
